import { ShippingPlanData } from '@/types';
import { Core, SHIPPING_PLAN, SHIPPING_PLANS } from '../Core';

interface UploadShippingPlanData {
  data: {
    shippingPlanFileBase64: ArrayBuffer | string | null;
    fileName?: string;
    customerId: number;
  };
}

class ShippingPlan extends Core {
  getShippingPlan = async () => this.get<ShippingPlanData>(SHIPPING_PLANS());

  uploadShippingPlan = async ({ data }: UploadShippingPlanData) =>
    this.post(SHIPPING_PLAN(), data);

  deleteShippingPlan = async (documentId: number) =>
    this.delete(SHIPPING_PLAN(documentId));
}

export const shippingPlan = new ShippingPlan();
